<script>
export default {
    props: {
        variant: {
            default: null,
        }
    },
    data() {
        return {
            showLoading: false,
            form: {
                discount: {
                    discount_type: null,
                    discount_amount: null
                }
            }
        };
    },
    watch: {
        form: {
            handler(val) {
                if (this.form != null && this.form.discount) {
                    if (this.form.discount.discount_type != undefined && this.form.discount.discount_type == "FIXED_AMOUNT" && this.form.discount.discount_amount > 0)
                        this.form.price_after_discount = this.form.price - this.form.discount.discount_amount
                    if (this.form.discount.discount_type != undefined && this.form.discount.discount_type == "PERCENTAGE" && this.form.discount.discount_amount > 0)
                        this.form.price_after_discount = this.form.price * ((100 - this.form.discount.discount_amount) / 100)
                    if (this.form.discount.discount_type == "" || this.form.discount.discount_amount == "")
                        this.form.price_after_discount = Math.floor(this.form.price)
                }
            },
            deep: true
        },
        variant: {
            handler(val) {
                this.form = this.variant
                if (this.variant != null) {
                    if (this.variant.status == "ACTIVE")
                        this.variant.status = "active"
                    if (this.variant.status == "DISABLED")
                        this.variant.status = "disabled"
                    if (this.variant == null || this.variant.discount == null) {
                        this.form.discount = {}
                        this.form.discount.discount_type = null
                        this.form.discount.discount_amount = null
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        submit() {
            if (this.form.status == true)
                this.form.status = "active"
            if (this.form.status == false)
                this.form.status = "disabled"

            if (this.form.discount != null && this.form.discount.discount_amount == 0.00)
                this.form.discount.discount_amount = null
            this.form.status = "disabled"
            this.$emit("handleVariantUpdate", this.form);
        },
        reset() {
            this.form = {
                discount: {
                    discount_type: null,
                    discount_amount: null
                }
            };
        }
    },
};
</script>

<template>
    <div class="modal fade" tabindex="-1" id="edit_variant" rel="">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">

                    <!--begin::Close-->
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" id="close" data-bs-dismiss="modal"
                        aria-label="Close">
                        <span class="svg-icon svg-icon-2x">X</span>
                    </div>
                    <!--end::Close-->
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-4">
                            <h2>
                                {{ $t('تعديل أسعار المنتج') }}
                            </h2>
                        </div>
                        <div class="col-md-8">
                            <div class="d-flex justify-content-end"><!--begin::Button--><a data-bs-dismiss="modal"
                                    aria-label="Close" data-kt-contacts-type="cancel" class="btn btn-light me-3">إلغاء
                                    الأمر</a><!--end::Button--><!--begin::Button--><button type="submit" @click="submit"
                                    data-kt-contacts-type="submit" class="btn btn-primary btn-app"
                                    data-text="إضافة تصنيف"><span class="indicator-label">{{ $t('save') }}</span><span
                                        class="indicator-progress">{{ $t('pleaseWait') }}<span
                                            class="spinner-border spinner-border-sm align-middle ms-2"></span></span></button><!--end::Button-->
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="variant != null">
                        <div class="col-xl-3 col-lg-4">
                            <div class="card mb-5">
                                <div class="card card-body">
                                    <div class="col-md-12">
                                        <div class="text-center">
                                            <img class="product-img" :src="variant?.Thumbnail" />
                                        </div>
                                        <p class="mb-2 mt-3 sku-number-styles fs-5"><span class="sku-number">{{ variant?.sku
                                        }}</span><span class="sku-header">{{ $t('sku') }}</span></p>
                                        <h2 class="fs-4 mb-4">{{ variant?.product?.sku }}</h2>
                                        <p class="pt-4 border-top">{{ variant?.product?.title }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card card-body">
                                    <div class="col-md-12">
                                        <table class="w-100">
                                            <tr>
                                                <th class="fw-light">{{ $t('sku') }}</th>
                                                <td class="text-end text-black fw-bolder">{{ variant?.product?.sku }}</td>
                                            </tr>
                                            <tr>
                                                <th class="fw-light">{{ $t('identifierType') }}</th>
                                                <td class="text-end text-black fw-bolder">{{ variant?.identifier_type }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="fw-light">{{ $t('identifierValue') }}</th>
                                                <td class="text-end text-black fw-bolder">{{ variant?.identifier_value }}
                                                </td>
                                            </tr>
                                            <tr v-for="option, index in variant?.variant?.option_values">
                                                <th class="fw-light">{{ option.option.title }}</th>
                                                <td class="text-end text-black fw-bolder">{{ option.title }}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-8">
                            <div class="card mb-10">
                                <div class="card-header align-content-center" type="button" data-bs-toggle="collapse"
                                    :data-bs-target="'#collapse' + index" aria-expanded="false">
                                    <h2 class="mb-0 d-inline fs-2 lh-xl"><img alt="Logo"
                                            src="assets/media/svg/brand-logos/amazon.svg" class="h-35px me-3" />{{
                                                option?.marketplace?.name }}</h2>
                                </div>

                                <div class="card-body">

                                    <div class="row py-3">
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('quantity') }}</label>
                                                <input class="form-control" name="quantity" v-model="form.quantity"
                                                    type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('price') }}</label>
                                                <input class="form-control" name="price" v-model="form.price" type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('discountType')
                                                }}</label>
                                                <select class="form-control" name="discount_type"
                                                    v-model="form.discount.discount_type">
                                                    <option value="FIXED_AMOUNT">{{ $t('amount') }}</option>
                                                    <option value="PERCENTAGE">{{ $t('percentage') }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('discountValue')
                                                }}</label>
                                                <input class="form-control" name="discount_amount"
                                                    v-model="form.discount.discount_amount" type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group mb-4">
                                                <label for="_6541f8444bfed" class=" form-label">{{ $t('priceAfterDiscount')
                                                }}</label>
                                                <input class="form-control" name="discounted_price" disabled
                                                    v-model="form.price_after_discount" type="number">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="form-check form-switch form-check-custom form-check-solid">
                                                <span class="form-check-label fw-semibold text-muted">
                                                    {{ $t('productAvailable') }}
                                                </span>
                                                <input class="form-check-input" type="checkbox" value="1"
                                                    :checked="form.status == 'ACTIVE'" v-model="form.status">
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
/* #edit_product .modal-dialog {
    max-width: 80%;
} */
.modal-body .plus-icon-container {
    display: none !important;
}

.modal-body .product-img {
    max-width: 100%;
}

.modal-body .collapsed .plus-icon-container {
    display: inline-flex !important;
}

.modal-body .minus-icon-container {
    display: inline-flex !important;
}

.modal-body .collapsed .minus-icon-container {
    display: none !important;
}

.modal-body .plus-icon-container {
    background-color: #fff;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 20px;
}

.modal-body .card .card-body,
.modal-body .card .card-header {
    padding: 1rem 1.15rem !important;

}

.modal-body .plus-icon {
    fill: rgba(88, 88, 88, 0.9);
}

.modal-body .minus-icon-container {
    background-color: rgba(236, 85, 47, 0.1);
    width: 40px;
    height: 40px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 20px;
}

.modal-body .minus-icon {
    fill: #ec552f;
}

.modal-body .card {
    border: 1px solid #eff2f5;
}

.modal-body .collapsed.card-header {
    border-bottom: unset;
}

.modal-body .form-check.form-check-custom {
    justify-content: space-between;
}

.modal-body .card-header {
    border-bottom: 1px solid #eff2f5;
}

.sku-number-styles {
    direction: ltr;
    text-align: end;
}

.sku-number-styles .sku-number {
    color: #ec552f;
}

.pt-4.border-top {
    border-top-style: dashed !important;
}

.form-switch.form-check-solid .form-check-input {
    height: 2.25rem;
}

.form-switch .form-check-input:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e") !important;
}

.form-check.form-check-solid .form-check-input:checked,
input:checked[type="radio"]:not(.reflex) {

    background-color: #ec552f !important;
}
</style>
